/**
 * Affiliate Configuration
 * This file is auto-generated based on AFFILIATE environment variable
 * Reads from src/config/affiliates.json
 * 
 * Generated at: 2026-03-30T14:09:27.189Z
 */

// Affiliate brand name (used for logo filename and UI fallback)
export const AFFILIATE = 'LifeLatinz'

// Direct affiliate URL (used for redirects / outbound)
export const AFFILIATE_LINK = ''

// Logo filename (always at public/images/logos/{AFFILIATE}.png)
export const AFFILIATE_LOGO_FILE = 'LifeLatinz.png'

const affiliateConfig = { AFFILIATE, AFFILIATE_LINK, AFFILIATE_LOGO_FILE }
export default affiliateConfig
